import { Component } from 'react';
import ReactDOM from 'react-dom';

import JoinOrEditWidget from './joinButton/JoinOrEditWidget';

class ClubJoinButton extends Component {
  render() {
    const { slug, node, deliveryMethod = 'ship' } = this.props;
    return ReactDOM.createPortal(
      <JoinOrEditWidget slug={slug} deliveryMethod={deliveryMethod} />,
      node
    );
  }
}

export default ClubJoinButton;
